// MAIN COLORS DEFAULT
let colors = {
  primary : '#007bff',
  success : '#28C76F',
  danger  : '#EA5455',
  warning : '#FF9F43',
  dark    : '#1E1E1E',
}

// THEME CONFIG
export const themeConfig = {
  routerTransition  : "zoom-fade", 
  theme             : "light",    
}

// IRIS CONFIG
export const irisConfig = {
  customers      : "YS22HIiKAxNYl6gIQjXA",
  sites          : "NdZCjy9ZPbxODDEUIhzf",
  menuHeaderRight     : "sx5fa6H45wRPsZ8Id9CK",
  menuHeaderLeft     : "7y6IsOqqzKYmzavfigdT",
  menuFooter     : "ewfmoX3Aq0iPnyo07Uxi",
  googleAnalyticsID : "UA-183423065-1"
} 

import Vue from 'vue'
import Vuesax from 'vuesax'
Vue.use(Vuesax, { theme:{ colors } })
